module.exports = "<div class=modal tabindex=-1 role=dialog> <div class=modal-dialog> <div class=modal-content> <div class=modal-body> <div> {{errorMessage | translate}} </div> </div> </div> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/performance-review/performance-review-invite/performance-review-invite/performance-review-invite.modal.user-conflict.html
 ** module id = 250
 ** module chunks = 0
 **/